import Vue from 'vue'
import Router from 'vue-router'
import pathPrefix from './pathPrefix.js'

Vue.use(Router) 

export default new Router({
  mode: 'history',
  routes: [
    {
      path: `${pathPrefix}/`,
      redirect: `${pathPrefix}/home`
    },
    {
      path: `${pathPrefix}/home`,
      name: 'home',
      component: () => import('./pages/Home.vue')
    },
    {
      path: `${pathPrefix}/about`,
      name: 'about',
      component: () => import('./pages/About.vue')
    },
    {
      path: `${pathPrefix}/contact`,
      name: 'contact',
      component: () => import('./pages/Contact.vue')
    },
    {
      path: `${pathPrefix}/register`,
      name: 'register',
      component: () => import('./pages/Register.vue')
    },
    {
      path: `${pathPrefix}/partners`,
      name: 'partners',
      component: () => import('./pages/Partners.vue')
    },
    {
      path: `${pathPrefix}/partners/uipath`,
      name: 'UiPath',
      component: () => import('./components/partners/DedicatePage1.vue')
    },
    {
      path: `${pathPrefix}/partners/bitdefender`,
      name: 'Bitdefender',
      component: () => import('./components/partners/DedicatePage2.vue')
    },
    {
      path: `${pathPrefix}/partners/bcr`,
      name: 'BCR',
      component: () => import('./components/partners/DedicatePage3.vue')
    },
    {
      path: `${pathPrefix}/partners/enevo`,
      name: 'Enevo',
      component: () => import('./components/partners/DedicatePage4.vue')
    },
    {
      path: `${pathPrefix}/partners/computaris`,
      name: 'Computaris',
      component: () => import('./components/partners/DedicatePage5.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return { selector: to.hash }
		} else if (savedPosition) {
    		return savedPosition;
    	} else {
			return { x: 0, y: 0 }
		}
	}
})
